import { useAppSelector } from '@pkg/hooks';

import { type NFTItem } from '@app/store/types/nft-manager';

import { LIQUID_ID_FACES_LENGTH } from '../../LiquidIDSection/config';

export const VIDEO_MIME_TYPES = ['application/mp4', 'video/mp4'];

export const useHandleDisabledItems = () => {
    const liquidIDItems = useAppSelector((state) => state.yatPage.liquidIDItems);
    const toggledAssets = useAppSelector((state) => state.yatPage.pageAssets.toggled);
    const editingLiquidID = useAppSelector((state) => state.yatPage.editStates.editingLiquidID);
    const draggingItems = useAppSelector((state) => state.nftManager.draggingItems);
    const isLiquidIDVideoAllowed = true;
    const selectedAllItems = useAppSelector((state) => state.nftManager.selectedAllItems);

    const handleIsDisabledPageItem = (item: NFTItem, error?: boolean) => {
        if (error) return true;
        if (selectedAllItems) return false;
        if (editingLiquidID) {
            const itemContent = item.content;
            const isVideo = Boolean(
                (itemContent?.mime_type && VIDEO_MIME_TYPES.includes(itemContent?.mime_type)) ||
                    itemContent?.video ||
                    itemContent?.animation_url,
            );

            const isLiquidIDComplete = liquidIDItems.filter(Boolean)?.length === LIQUID_ID_FACES_LENGTH;
            const allowedType = !isVideo || isLiquidIDVideoAllowed;

            return !allowedType || isLiquidIDComplete;
        }

        const liquidIDSelected = Boolean(
            editingLiquidID && liquidIDItems.some((liquidIdItem) => liquidIdItem && liquidIdItem.id == item.id),
        );
        if (!liquidIDSelected) {
            // To prevent displaying an item as added if it has been removed from the page
            // and query didn't update the items in the manager
            const dragging = draggingItems.some((draggingId) => draggingId == item.id);
            const presentAndNotRemoved = item.content?.on_page && toggledAssets[item.id] !== 'removed';
            return dragging || presentAndNotRemoved || toggledAssets[item.id] === 'added';
        }

        return false;
    };

    return { handleIsDisabledPageItem };
};
